module.exports = {
      id: "default-author-image-usage",
      viewBox: "0 0 48 48",
      url: "/" + "sprite-326d1762f7ed1f924194ae9c5468ee69.svg#default-author-image",
      toString: function () {
        return this.url;
      }
    }